// Events.js
// utilities/Events.js
import { timestampFromDate } from 'utilities/DateTime';

/**
 * Clears event dates back to defaults.
 * 
 * @param {boolean} keepStartNow - If true, reset startDate to "now" instead of null.
 * @returns {Object} New event object with cleared dates.
 */
export function clearDates() {
  return {
    startDate: null,
    startPrecision: null,
    endDate: null,
    endPrecision: null,
    isRange: false,
  };
}

/**
 * Returns a default {date, precision} object.
 * - Date is today at midnight
 * - Precision is "date" (no time)
 */
export function getDefaultDate() {
  const now = new Date();
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  return {
    date: timestampFromDate(midnight),
    precision: 'date',
  };
}
